module.exports = __webpack_public_path__ + "static/media/icon_salesforce.b847b1c5.svg";